import { render, staticRenderFns } from "./RevenueForm.vue?vue&type=template&id=000b3cb8&scoped=true&"
import script from "./RevenueForm.vue?vue&type=script&lang=js&"
export * from "./RevenueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b3cb8",
  null
  
)

export default component.exports